/**
 * 강의 편집 임시저장 유틸리티
 * localStorage를 사용하여 편집 중인 데이터를 자동으로 저장하고 복원합니다
 */

const AUTOSAVE_PREFIX = 'course_autosave_';

export interface AutosaveData {
  courseId: string;
  timestamp: number;
  data: any;
}

/**
 * 임시저장 데이터 저장
 */
export const saveAutosaveData = (courseId: string, data: any): void => {
  try {
    const key = `${AUTOSAVE_PREFIX}${courseId}`;
    const autosaveData: AutosaveData = {
      courseId,
      timestamp: Date.now(),
      data,
    };
    localStorage.setItem(key, JSON.stringify(autosaveData));
  } catch (error) {
    console.warn('[Autosave] 임시저장 실패:', error);
  }
};

/**
 * 임시저장 엔트리 전체를 불러오기
 */
export const loadAutosaveEntry = (courseId: string): AutosaveData | null => {
  try {
    const key = `${AUTOSAVE_PREFIX}${courseId}`;
    const stored = localStorage.getItem(key);

    if (!stored) {
      return null;
    }

    const autosaveData: AutosaveData = JSON.parse(stored);
    return autosaveData;
  } catch (error) {
    console.warn('[Autosave] 임시저장 데이터 불러오기 실패:', error);
    return null;
  }
};

/**
 * 임시저장 데이터 불러오기 (실제 데이터만 반환)
 */
export const loadAutosaveData = (courseId: string): any | null => {
  const entry = loadAutosaveEntry(courseId);
  return entry?.data ?? null;
};

/**
 * 임시저장 데이터 삭제
 */
export const clearAutosaveData = (courseId: string): void => {
  try {
    const key = `${AUTOSAVE_PREFIX}${courseId}`;
    localStorage.removeItem(key);
  } catch (error) {
    console.warn('[Autosave] 임시저장 데이터 삭제 실패:', error);
  }
};


/**
 * 임시저장 데이터 존재 여부 확인
 */
export const hasAutosaveData = (courseId: string): boolean => {
  const key = `${AUTOSAVE_PREFIX}${courseId}`;
  return localStorage.getItem(key) !== null;
};
